<template>
  <div>
    <div
      class="c-rich-text"
      v-html="nodes"
      @click="replayImgShow($event)"
    ></div>
    <community-preview :show.sync="show" :query="query"  />
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import { RE_RICHTEXT_VIDEO_TAG_S } from "@/utils/constants";
import communityPreview from "@/components/community-preview/community-preview.vue";
export default {
  name: "c-rich-text",
  props: {
    html: {
      type: String,
      required: true,
    },
    attachments: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    communityPreview,
  },
  data() {
    return {
      show: false,
      play: require("../../assets/image/common/video/video-play.png"),
      video: "",
      poster: "",
      imgshow: false,
      urls: [],
      urlsIndex: 0,
      query: {},
    };
  },
  computed: {
    nodes() {
      return this.html.replace(
        RE_RICHTEXT_VIDEO_TAG_S,
        `<div class="video-placeholder" >
					<img src="$2" video="$1" poster="$2" />
					<img class="icon" src="${this.play}" video="$1" poster="$2" />
				</div>`
      );
    },
  },
  methods: {
    swiperChange(e) {
      this.urlsIndex = e;
    },
    filtration(type) {

      return this.attachments.filter((v) => v.type === type);
    },
    replayImgShow(e) {
      let type = "";
      let item = "";
      if (e.target.tagName == "IMG") {
        event.stopPropagation();
        // 视频预览
        if (e.target?.attributes?.video) {
          type = 2
          item = e.target?.attributes?.video.value;
          // this.show = true;
          // this.video = e.target?.attributes?.video.value;
          // this.poster = e.target?.attributes?.poster.value;
        } else {
          type = 1;
          item = e.target.src;
          // 图片预览
          // this.urls = [];
          // this.urlsIndex = 0;
          // this.urls = this.attachments
          //   .filter((v) => v.type === 1)
          //   .map((v) => v.url);
          // let find = this.urls.findIndex((item) => item == e.target.src);
          // this.urlsIndex = find;
          // this.imgshow = true;
        }
        let list = this.filtration(type);
        console.log(list,"list");
        this.query = {
          type,
          current: list.findIndex((find) => find.url == item),
          list,
          item:item
        };
        console.log(this.show,">>>");
        this.show = true;
         
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.c-rich-text {
  line-height: 0.773333rem /* 58/75 */;
  font-size: 0.373333rem /* 28/75 */;
  color: #333333;
  overflow: hidden;
  word-break: break-all;
  ::v-deep img {
    display: block;
    max-width: 100%;
  }
  ::v-deep video{
    display: block;
    max-width: 100%;
  }
  ::v-deep .video-placeholder {
    position: relative;
    .icon {
      position: absolute;
      z-index: 1;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 1.28rem /* 96/75 */;
      height: 1.28rem /* 96/75 */;
    }
  }
  p {
		white-space: pre-wrap;
	}
}

</style>
